import {
  DocumentFilter, FileDocument, Label, Successable,
} from '@/model';
import api from '@/rest-api';
import { RouteNames } from '@/router/route-names';
import realms from '@/store/realms';
import DocumentsView from '@/views/DocumentsView.vue';
import Vue, { VNode } from 'vue';

export default Vue.extend({
  name: 'DocumentsController',
  components: {
    DocumentsView,
  },

  data() {
    return {
      loading: false,
      documents: [] as FileDocument[],
      filter: {} as DocumentFilter,
    };
  },

  async mounted() {
    if (localStorage.getItem('documentFilter')) {
      this.loadFilter();
    } else {
      this.resetFilter();
    }
    this.load();
  },

  methods: {
    async load() {
      this.loading = true;
      this.documents = await api.documentsFilter(this.filter);
      this.loading = false;
    },
    async save(doc: Partial<FileDocument>, editLabels: Label[], file: File | undefined, callback: Successable<FileDocument>) {
      try {
        this.loading = true;
        const savedLabels = await Promise.all(editLabels.map((l) => (l.id < 1 ? api.saveLabel(l) : Promise.resolve(l))));
        const desc = file ? await api.uploadFile(file) : doc.file;
        callback.onSuccess(await api.saveDocument({ ...doc, file: desc, labels: savedLabels.map((l) => l.id) }));
        this.load();
      } catch {
        callback.onFailure();
      }
    },
    reingest(doc: FileDocument) {
      api.ingestDescriptors(doc.id).then((desc) => {
        if (desc[0].job) {
          this.$router.push({
            name: RouteNames.DuplicateJob,
            params: { duplicateJobId: `${desc[0].job.id}` },
            query: { pipeline: 'textract' },
          });
        }
      });
    },
    onFilterChange(filter: DocumentFilter) {
      this.filter = filter;
      localStorage.setItem('documentFilter', JSON.stringify(filter));
      this.load();
    },
    loadFilter() {
      const filter = localStorage.getItem('documentFilter');
      if (filter) {
        this.filter = JSON.parse(filter);
      }
    },
    resetFilter() {
      const realm = realms.getters.main;
      localStorage.removeItem('documentFilter');
      if (realm) {
        this.filter = { realms: [realm] };
      }
      this.load();
    },
  },

  render(create): VNode {
    return create(
      DocumentsView, {
        props: {
          loading: this.loading,
          documents: this.documents,
          filter: this.filter,
        },
        on: {
          load: this.load,
          save: this.save,
          reingest: this.reingest,
          filterChange: this.onFilterChange,
          resetFilter: this.resetFilter,
        },
      },
    );
  },

});
